// initial state
const getDefaults = () => ({
  showAllFields: false,
  showRaw: false,
  uploadsView: null,
  artistArtView: null,
  artistUploadTips: true,
  searchAdvanced: true,
  searchRefresh: null,
  projectRefresh: null,
  dismissed: null,
  cartRefresh: null,
  customSizes: [],
  projectsView: null,          // 'grid' | 'list' | null (null = default grid)
  dsSpreadsheetColumns: null,  // persisted column picker string for DS spreadsheet
  projectsIndexColumns: null,  // persisted column picker string for projects index list
  dsGroupByWorkspace: true,    // group items by workspace in grid/list view
  dsShowDeleted: false,        // include soft-deleted design studio items
  dsThumbnailPxDetail: 5,      // px-per-inch for project detail grid
  dsThumbnailPxIndex: 1,       // px-per-inch for project index lanes
  projectInspectorOpen: false,
  projectItemPanelOpen: true,         // project detail summary / bulk editor
  projectBrowseListPanelOpen: false,  // browse index bulk editor
  projectBrowseItemPanelOpen: true,   // browse item editor
  migrationDebugEnabled: false,
  pinnedProject: null,  // { id, name } for the projects2 pin bar
})

const state = getDefaults()

// getters
const getters = {
  omitFields(state) {
    return state.showAllFields
      ? () => false
      : field => field.read_only
  },
}

// actions
const actions = {
}

// mutations
const mutations = {
  setPreference(state, data) {
    Object.keys(data).forEach(key => {
      state[key] = data[key]
    })
  },
  clear(state) {
    const defaults = getDefaults()
    Object.keys(state).forEach(key => {
      state[key] = defaults[key]
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
